import VuePdfEmbed from 'vue-pdf-embed'

// optional styles
import 'vue-pdf-embed/dist/styles/annotationLayer.css'
import 'vue-pdf-embed/dist/styles/textLayer.css'

export default defineNuxtPlugin(({ vueApp }) => {
  vueApp.component('VuePdfEmbed', VuePdfEmbed)
})
